<template>
  <div class="text">
    <ul>
      <li>Debe tener un largo mínimo de 12 caracteres.</li>
      <li>Debe incluir al menos una letra en mayúscula.</li>
      <li>Debe contener al menos una letra en minúscula.</li>
      <li>Debe contener al menos un dígito del 0 al 9.</li>
      <li>Debe contener al menos un símbolo especial de tipo
      <code>&dollar;&percnt;&Hat;&amp;&ast;&lpar;&rpar;&lowbar;&plus;&vert;&#x7E;&#x2D;&equals;&bsol;&grave;&lcub;&rcub;&lsqb;&rsqb;&colon;&quot;&semi;&apos;&lt;&gt;&quest;&comma;&sol;.</code></li>
      <li>No debe contener palabras de diccionario, de ningún
      idioma. ej. "zanahoria123" no es palabra del diccionario. </li>
      <li>No deben contener información personal o de la
      organización como fechas, direcciones, nombres u otros.</li>
      <li>No debe contener números consecutivos (secuenciales ni el mismo número).</li>
      <li>No debe contener letras consecutivas (secuenciales ni la misma letra).</li>
    </ul>
  </div>
</template>

<script>

export default {
  name: 'PasswordRules',
  data () {
    return {
    }
  },
  created: function () {
  }
}
</script>

<style lang="scss" scoped>

.text {
  font-size: .9em;

  > ul li {
    margin-bottom: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/partials/PasswordRules.vue